export default __webpack_public_path__ + "static/SR China - FSSC 22000 - Certificate-ab88b9d8674791b970fdba8ba2cdece6.pdf";